/* DMP PERF 2026-07-07 : chargement differe des cards du mega-menu via Section Rendering API.
   Les <ul data-dmp-lazy-cards data-source="..."> sont remplis au premier survol/tap du menu.
   Retirer ce fichier + restaurer snippets/products-mega-menu.liquid pour rollback. */
(function () {
  'use strict';
  if (window.__dmpMegaLazy) return;
  window.__dmpMegaLazy = true;

  var cache = {};
  var idle = window.requestIdleCallback
    ? function (fn) { window.requestIdleCallback(fn, { timeout: 1500 }); }
    : function (fn) { window.setTimeout(fn, 250); };

  function fetchCards(source) {
    var url = source + (source.indexOf('?') > -1 ? '&' : '?') + 'section_id=dmp-mega-menu-cards';
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
    }
    return cache[url];
  }

  function load(ul) {
    if (!ul || ul.getAttribute('data-dmp-loaded') || !ul.getAttribute('data-source')) return;
    ul.setAttribute('data-dmp-loaded', '1');
    fetchCards(ul.getAttribute('data-source'))
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-dmp-cards-payload]');
        ul.innerHTML = fresh ? fresh.innerHTML : '';
      })
      .catch(function () {
        ul.removeAttribute('data-dmp-loaded');
        ul.innerHTML = '';
      });
  }

  function loadMenu(root) {
    var uls = Array.prototype.slice.call(root.querySelectorAll('[data-dmp-lazy-cards]'));
    if (!uls.length) return;
    var active = root.querySelector('.products-mega-menu__item--active [data-dmp-lazy-cards]');
    if (active) load(active);
    var i = 0;
    (function next() {
      while (i < uls.length && uls[i].getAttribute('data-dmp-loaded')) i++;
      if (i >= uls.length) return;
      load(uls[i++]);
      idle(next);
    })();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('products-mega-menu'), function (el) {
      var primed = false;
      var prime = function () {
        if (primed) return;
        primed = true;
        loadMenu(el);
      };
      el.addEventListener('mouseover', prime, { passive: true });
      el.addEventListener('touchstart', prime, { passive: true });
      el.addEventListener('focusin', prime);
      el.addEventListener('mouseover', function (e) {
        if (!e.target || !e.target.closest) return;
        var item = e.target.closest('[id^="ProductsMegaMenu-Item"]');
        if (item) load(item.querySelector('[data-dmp-lazy-cards]'));
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
